<script lang="ts" setup>
import { PropType } from 'vue'

type DataType = {
  text: string
  unit?: string
  value?: any
  type?: string
}

const props = defineProps({
  data: {
    type: [Object, null] as PropType<DataType | null>,
    required: true
  }
})
</script>

<template>
  <tr>
    <template v-if="data?.value !== undefined">
      <template v-if="data.type === 'indent'">
        <td style="width: 1%"></td>
        <td class="border-left-grey left-align">{{ data.text }}</td>
      </template>
      <template v-else>
        <td class="left-align" colspan="2">{{ data.text }}</td>
      </template>
      <td class="border-left-grey">{{ data.unit }}</td>
      <td class="border-left-grey">{{ data.value }}</td>
    </template>
    <template v-else>
      <td class="left-align" colspan="48">{{ data?.text }}</td>
    </template>
  </tr>
</template>

<style scoped>
.left-align {
  text-align: left;
}
</style>
